// with polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import permission from './directive/permission'
import style from './directive/style'
import loading from './directive/loading'
import store from './store/'
import i18n from './locales'
import { VueAxios } from './utils/request'
import ProLayout, { PageHeaderWrapper } from '@/components/ProLayout'
import FooterToolBar from '@/components/FooterToolbar'
import FileUpload from '@/components/FileUpload'
import themePluginConfig from '../config/themePluginConfig'
import { TableSetting } from '@/components'
import DictData from '@/components/DictData'
import DictTag from '@/components/DictTag'
import bootstrap from './core/bootstrap'
import { setupAntd } from './core/lazy_use'
import { setupAntdCompat } from './plugins/antd-compat'
import { setupFilters } from './utils/filter'
import './permission'
import './global.less'
import '@/assets/css/main.css'
import { getDicts } from '@/api/system/dict/data'
import { getConfigKey } from '@/api/system/config'
import {
  parseTime,
  resetForm,
  addDateRange,
  selectDictLabel,
  selectDictLabels,
  handleTree,
  tableSorter,
} from '@/utils/ruoyi'
import { download } from '@/utils/request'
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'

const app = createApp(App)
window.$vueApp = app
window.$router = router

setupAntd(app)
setupAntdCompat(app)
bootstrap()
app.use(router)
app.use(store)
app.use(permission)
app.use(style)
app.use(loading)
app.use(VueAxios)
app.use(i18n)
app.use(VueDirectiveImagePreviewer, { zIndex: '2019' })

app.component('pro-layout', ProLayout)
app.component('page-container', PageHeaderWrapper)
app.component('page-header-wrapper', PageHeaderWrapper)
app.component('footer-tool-bar', FooterToolBar)
app.component('file-upload', FileUpload)
app.component('table-setting', TableSetting)
app.component('dict-tag', DictTag)

DictData.install(app)
setupFilters(app)

app.config.globalProperties.routerAppend = (path, pathToAppend) =>
  path + (path.endsWith('/') ? '' : '/') + pathToAppend
app.config.globalProperties.getDicts = getDicts
app.config.globalProperties.getConfigKey = getConfigKey
app.config.globalProperties.parseTime = parseTime
app.config.globalProperties.resetForm = resetForm
app.config.globalProperties.addDateRange = addDateRange
app.config.globalProperties.selectDictLabel = selectDictLabel
app.config.globalProperties.selectDictLabels = selectDictLabels
app.config.globalProperties.download = download
app.config.globalProperties.handleTree = handleTree
app.config.globalProperties.tableSorter = tableSorter

window.umi_plugin_ant_themeVar = themePluginConfig.theme

// ============================================
// 错误处理配置
// ============================================

// 1. 忽略 ResizeObserver 循环限制错误（Ant Design Vue / ECharts 等触发的已知问题，不影响功能）
const isResizeObserverError = (msg) =>
  typeof msg === 'string' && msg.includes('ResizeObserver')
const resizeObserverErrHandler = (error) => {
  const msg = error && (error.message || error)
  return isResizeObserverError(String(msg))
}

// 2. Vue 全局错误处理器
app.config.errorHandler = (err, instance, info) => {
  // 如果是 ResizeObserver 错误，直接忽略
  if (resizeObserverErrHandler(err)) {
    return
  }
  
  // 其他错误正常处理并输出
  console.error('Vue 错误:', err)
  console.error('组件实例:', instance)
  console.error('错误信息:', info)
}

// 3. 全局 window 错误事件监听器（捕获阶段优先，避免 webpack-dev-server overlay 显示）
window.addEventListener('error', (event) => {
  const msg = event.message || (event.error && event.error.message) || ''
  if (isResizeObserverError(msg)) {
    event.stopImmediatePropagation()
    event.preventDefault()
    return true
  }
}, true)

// 4. 全局未处理的 Promise 拒绝错误
window.addEventListener('unhandledrejection', (event) => {
  const msg = event.reason && (event.reason.message || event.reason)
  if (isResizeObserverError(msg && String(msg))) {
    event.preventDefault()
  }
})

// 5. Vue 警告处理器（用于抑制已知的警告，不影响功能）
app.config.warnHandler = (msg, instance, trace) => {
  if (isResizeObserverError(msg)) return
  // 忽略递归更新的警告（但记录到控制台以便调试）
  if (msg && msg.includes('Maximum recursive updates')) {
    console.warn('Vue 递归更新警告（已抑制）:', msg)
    console.warn('组件追踪:', trace)
    return
  }
  // 其他警告正常显示
  console.warn(msg, instance, trace)
}

app.mount('#app')
